<template>
  <div class="modal-card" style="width: 900px; max-width: 95vw;">
    <header class="modal-card-head">
      <p class="modal-card-title">
        <b-icon icon="account-group"></b-icon>
        {{ isEdit ? 'Actualizar' : 'Asignar' }} Comisión Precalificadora
      </p>
    </header>
      
      <section class="modal-card-body">
        <!-- Información del proceso -->
        <div class="notification is-info is-light mb-5">
          <div class="columns is-vcentered">
            <div class="column">
              <p class="has-text-weight-bold is-size-5 mb-1">
                <b-icon icon="calendar-check"></b-icon>
                Proceso de Evaluación {{ currentYear }}
              </p>
              <p class="is-size-6">
                Asigne 2 miembros de la comisión precalificadora de su departamento.
                Estos miembros podrán revisar y firmar digitalmente las precalificaciones.
              </p>
            </div>
            <div class="column is-narrow">
              <b-icon icon="account-group" size="is-large" custom-class="has-text-info"></b-icon>
            </div>
          </div>
        </div>

        <div class="columns">
          <!-- Formularios de miembros -->
          <div class="column is-7">
            <div class="columns">
              <!-- Formulario Miembro 1 -->
              <div class="column">
                <div class="box committee-member-box">
                  <div class="has-text-centered mb-3">
                    <b-icon icon="account-circle" size="is-large" custom-class="has-text-primary"></b-icon>
                    <p class="has-text-weight-bold is-size-5 mt-2">Miembro 1</p>
                  </div>
                  
                  <b-field 
                    label="Nombre Completo" 
                    :type="errors.member_1_name ? 'is-danger' : ''" 
                    :message="errors.member_1_name"
                  >
                    <b-input
                      v-model="formData.member_1_name"
                      placeholder="Nombre completo"
                      icon="account"
                      @input="clearError('member_1_name'); checkDuplicateUsers()"
                      :disabled="isSaving"
                    ></b-input>
                  </b-field>

                  <b-field 
                    label="Email Institucional" 
                    :type="errors.member_1_email ? 'is-danger' : ''" 
                    :message="errors.member_1_email"
                  >
                    <b-input
                      v-model="formData.member_1_email"
                      type="email"
                      placeholder="correo@usach.cl"
                      icon="email"
                      @input="validateEmail('member_1_email'); checkDuplicateUsers()"
                      :disabled="isSaving"
                    ></b-input>
                  </b-field>

                  <b-button 
                    v-if="formData.member_1_email"
                    size="is-small" 
                    type="is-light"
                    icon-left="close"
                    @click="clearMember('member_1')"
                    expanded
                    :disabled="isSaving"
                  >
                    Limpiar
                  </b-button>
                </div>
              </div>

              <!-- Formulario Miembro 2 -->
              <div class="column">
                <div class="box committee-member-box">
                  <div class="has-text-centered mb-3">
                    <b-icon icon="account-circle" size="is-large" custom-class="has-text-link"></b-icon>
                    <p class="has-text-weight-bold is-size-5 mt-2">Miembro 2</p>
                  </div>
                  
                  <b-field 
                    label="Nombre Completo" 
                    :type="errors.member_2_name ? 'is-danger' : ''" 
                    :message="errors.member_2_name"
                  >
                    <b-input
                      v-model="formData.member_2_name"
                      placeholder="Nombre completo"
                      icon="account"
                      @input="clearError('member_2_name'); checkDuplicateUsers()"
                      :disabled="isSaving"
                    ></b-input>
                  </b-field>

                  <b-field 
                    label="Email Institucional" 
                    :type="errors.member_2_email ? 'is-danger' : ''" 
                    :message="errors.member_2_email"
                  >
                    <b-input
                      v-model="formData.member_2_email"
                      type="email"
                      placeholder="correo@usach.cl"
                      icon="email"
                      @input="validateEmail('member_2_email'); checkDuplicateUsers()"
                      :disabled="isSaving"
                    ></b-input>
                  </b-field>

                  <b-button 
                    v-if="formData.member_2_email"
                    size="is-small" 
                    type="is-light"
                    icon-left="close"
                    @click="clearMember('member_2')"
                    expanded
                    :disabled="isSaving"
                  >
                    Limpiar
                  </b-button>
                </div>
              </div>
            </div>

            <!-- Advertencias de validación -->
            <div v-if="duplicateUserWarning" class="notification is-warning">
              <b-icon icon="alert"></b-icon>
              <strong>Atención:</strong> No puede asignar el mismo usuario como Miembro 1 y Miembro 2.
            </div>

            <div v-if="Object.keys(errors).length > 0" class="notification is-danger is-light">
              <b-icon icon="alert"></b-icon>
              Por favor corrija los errores marcados antes de continuar.
            </div>
          </div>

          <!-- Lista de usuarios disponibles -->
          <div class="column is-5">
            <div class="box" style="height: 100%; background: #fafafa;">
              <p class="has-text-weight-bold is-size-5 mb-3">
                <b-icon icon="account-multiple"></b-icon>
                Usuarios del Departamento
              </p>
              
              <b-field>
                <b-input 
                  placeholder="Buscar por nombre o email..." 
                  v-model="userQuery" 
                  @input="debouncedSearch" 
                  icon="magnify"
                  :disabled="isSaving"
                ></b-input>
              </b-field>

              <p class="is-size-7 has-text-grey mb-2">
                Haga clic en "Asignar" para seleccionar un usuario
              </p>

              <div v-if="isLoadingUsers" class="has-text-centered py-5">
                <b-loading :is-full-page="false" :active="true"></b-loading>
              </div>

              <div v-else-if="availableUsers.length === 0" class="notification is-light">
                <b-icon icon="account-search"></b-icon>
                No se encontraron usuarios en su departamento.
              </div>

              <div v-else class="user-list">
                <div 
                  v-for="u in availableUsers" 
                  :key="u.id" 
                  class="user-card box"
                  :class="{ 'is-selected': isUserSelected(u) }"
                >
                  <div class="user-info">
                    <div class="user-name">
                      <b-icon icon="account-circle" size="is-small"></b-icon>
                      {{ u.name }}
                      <span v-if="u.has_committee_role" class="tag is-success is-light ml-2">
                        <b-icon icon="check-circle" size="is-small"></b-icon>
                        En comisión actual
                      </span>
                    </div>
                    <div class="user-email">{{ u.email }}</div>
                  </div>
                  <div class="user-actions">
                    <b-button 
                      size="is-small" 
                      type="is-primary" 
                      outlined
                      @click="selectUserFor('member_1', u)"
                      :disabled="isSaving || isUserSelectedAs('member_1', u)"
                    >
                      <b-icon icon="account-arrow-left" size="is-small"></b-icon>
                      <span>M1</span>
                    </b-button>
                    <b-button 
                      size="is-small" 
                      type="is-link" 
                      outlined
                      @click="selectUserFor('member_2', u)"
                      :disabled="isSaving || isUserSelectedAs('member_2', u)"
                    >
                      <b-icon icon="account-arrow-left" size="is-small"></b-icon>
                      <span>M2</span>
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer class="modal-card-foot is-justify-content-space-between">
        <div>
          <p class="is-size-7 has-text-grey">
            <b-icon icon="information" size="is-small"></b-icon>
            Los miembros recibirán códigos de verificación para firmar digitalmente
          </p>
        </div>
        <div>
          <b-button @click="close" :disabled="isSaving">
            Cancelar
          </b-button>
          <b-button
            type="is-primary"
            @click="save"
            :loading="isSaving"
            :disabled="!isFormValid"
          >
            <b-icon icon="save"></b-icon>
            <span>{{ isEdit ? 'Actualizar Comisión' : 'Asignar Comisión' }}</span>
          </b-button>
        </div>
      </footer>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AssignCommitteeModal',

  props: {
    existingCommittee: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      isEdit: false,
      committeeId: null,
      formData: {
        member_1_name: '',
        member_1_email: '',
        member_2_name: '',
        member_2_email: ''
      },
      userQuery: '',
      errors: {},
      isSaving: false,
      isLoadingUsers: false,
      currentYear: new Date().getFullYear(),
      availableUsers: [],
      duplicateUserWarning: false
    };
  },

  computed: {
    isFormValid() {
      return (
        this.formData.member_1_name.trim() !== '' &&
        this.formData.member_1_email.trim() !== '' &&
        this.formData.member_2_name.trim() !== '' &&
        this.formData.member_2_email.trim() !== '' &&
        this.isEmailValid(this.formData.member_1_email) &&
        this.isEmailValid(this.formData.member_2_email) &&
        this.formData.member_1_email !== this.formData.member_2_email &&
        !this.duplicateUserWarning &&
        Object.keys(this.errors).length === 0
      );
    }
  },

  created() {
    // debounce setup
    this.debouncedSearch = this.debounce(() => { this.loadAvailableUsers(); }, 300);
  },

  mounted() {
    this.loadExistingData();
    this.loadAvailableUsers();
  },

  methods: {
    debounce(func, wait = 200) {
      let timeout;
      return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    },

    loadExistingData() {
      if (this.existingCommittee) {
        // Modo edición
        this.isEdit = true;
        this.committeeId = this.existingCommittee.id;
        
        // Verificar si tiene la estructura del summary (con member_1 y member_2 como objetos)
        if (this.existingCommittee.member_1 && this.existingCommittee.member_2) {
          this.formData = {
            member_1_name: this.existingCommittee.member_1.name || '',
            member_1_email: this.existingCommittee.member_1.email || '',
            member_2_name: this.existingCommittee.member_2.name || '',
            member_2_email: this.existingCommittee.member_2.email || ''
          };
        } else {
          // Estructura plana (member_1_name, member_1_email, etc.)
          this.formData = {
            member_1_name: this.existingCommittee.member_1_name || '',
            member_1_email: this.existingCommittee.member_1_email || '',
            member_2_name: this.existingCommittee.member_2_name || '',
            member_2_email: this.existingCommittee.member_2_email || ''
          };
        }
      }
    },

    async loadAvailableUsers() {
      this.isLoadingUsers = true;
      try {
        const res = await axios.get('/committee_members/available_users', { 
          params: { 
            query: this.userQuery,
            process_year: this.currentYear
          } 
        });
        if (res.data.success) {
          this.availableUsers = res.data.users || [];
        }
      } catch (e) {
        console.error('Error loading available users', e);
        this.$buefy.toast.open({
          message: 'Error al cargar usuarios del departamento',
          type: 'is-danger',
          duration: 3000
        });
      } finally {
        this.isLoadingUsers = false;
      }
    },

    selectUserFor(slot, user) {
      if (slot === 'member_1') {
        this.formData.member_1_name = user.name;
        this.formData.member_1_email = user.email;
        this.clearError('member_1_name');
        this.clearError('member_1_email');
      } else if (slot === 'member_2') {
        this.formData.member_2_name = user.name;
        this.formData.member_2_email = user.email;
        this.clearError('member_2_name');
        this.clearError('member_2_email');
      }
      this.checkDuplicateUsers();

      // Mostrar feedback visual
      this.$buefy.toast.open({
        message: `${user.name} asignado como ${slot === 'member_1' ? 'Miembro 1' : 'Miembro 2'}`,
        type: 'is-success',
        duration: 2000
      });
    },

    clearMember(slot) {
      if (slot === 'member_1') {
        this.formData.member_1_name = '';
        this.formData.member_1_email = '';
        this.clearError('member_1_name');
        this.clearError('member_1_email');
      } else if (slot === 'member_2') {
        this.formData.member_2_name = '';
        this.formData.member_2_email = '';
        this.clearError('member_2_name');
        this.clearError('member_2_email');
      }
      this.checkDuplicateUsers();
    },

    isUserSelected(user) {
      return (
        this.formData.member_1_email.toLowerCase() === user.email.toLowerCase() ||
        this.formData.member_2_email.toLowerCase() === user.email.toLowerCase()
      );
    },

    isUserSelectedAs(slot, user) {
      if (slot === 'member_1') {
        return this.formData.member_1_email.toLowerCase() === user.email.toLowerCase();
      } else if (slot === 'member_2') {
        return this.formData.member_2_email.toLowerCase() === user.email.toLowerCase();
      }
      return false;
    },

    checkDuplicateUsers() {
      const email1 = this.formData.member_1_email.trim().toLowerCase();
      const email2 = this.formData.member_2_email.trim().toLowerCase();
      
      if (email1 && email2 && email1 === email2) {
        this.duplicateUserWarning = true;
      } else {
        this.duplicateUserWarning = false;
      }
    },

    close() {
      this.$parent.close();
    },

    isEmailValid(email) {
      const regex = /^[^\s@]+@usach\.cl$/i;
      return regex.test(email);
    },

    validateEmail(field) {
      this.clearError(field);
      
      const email = this.formData[field].trim().toLowerCase();
      
      if (!email) {
        this.errors[field] = 'El email es requerido';
        return;
      }

      if (!this.isEmailValid(email)) {
        this.errors[field] = 'Debe ser un email válido @usach.cl';
        return;
      }

      // Validar que los emails no sean iguales
      if (field === 'member_1_email' && email === this.formData.member_2_email.trim().toLowerCase()) {
        this.errors[field] = 'Los emails no pueden ser iguales';
      } else if (field === 'member_2_email' && email === this.formData.member_1_email.trim().toLowerCase()) {
        this.errors[field] = 'Los emails no pueden ser iguales';
      }

      // Forzar actualización
      this.$forceUpdate();
    },

    clearError(field) {
      if (this.errors[field]) {
        delete this.errors[field];
        this.$forceUpdate();
      }
    },

    validateForm() {
      this.errors = {};

      // Validar nombres
      if (!this.formData.member_1_name.trim()) {
        this.errors.member_1_name = 'El nombre es requerido';
      }
      if (!this.formData.member_2_name.trim()) {
        this.errors.member_2_name = 'El nombre es requerido';
      }

      // Validar emails
      this.validateEmail('member_1_email');
      this.validateEmail('member_2_email');

      // Verificar duplicados
      this.checkDuplicateUsers();

      return Object.keys(this.errors).length === 0 && !this.duplicateUserWarning;
    },

    async save() {
      if (!this.validateForm()) {
        this.$buefy.toast.open({
          message: 'Por favor corrija los errores del formulario',
          type: 'is-warning',
          duration: 3000
        });
        return;
      }

      this.isSaving = true;

      try {
        const endpoint = this.isEdit
          ? `/committee_members/${this.committeeId}`
          : '/committee_members';

        const method = this.isEdit ? 'put' : 'post';

        const response = await axios[method](endpoint, {
          member_1_name: this.formData.member_1_name.trim(),
          member_1_email: this.formData.member_1_email.trim().toLowerCase(),
          member_2_name: this.formData.member_2_name.trim(),
          member_2_email: this.formData.member_2_email.trim().toLowerCase(),
          process_year: this.currentYear
        });

        if (response.data.success) {
          this.$buefy.toast.open({
            message: response.data.message || 'Comisión asignada correctamente',
            type: 'is-success',
            duration: 3000
          });

          this.$emit('saved', response.data.committee);
          this.close();
        } else {
          throw new Error(response.data.error || 'Error al guardar la comisión');
        }
      } catch (error) {
        console.error('Error al guardar comisión:', error);
        this.$buefy.toast.open({
          message: error.response?.data?.error || 'Error al asignar la comisión',
          type: 'is-danger',
          duration: 5000
        });
      } finally {
        this.isSaving = false;
      }
    }
  }
};
</script>

<style scoped>
.committee-member-box {
  background: linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%);
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  transition: all 0.3s ease;
  height: 100%;
}

.committee-member-box:hover {
  border-color: #3273dc;
  box-shadow: 0 4px 12px rgba(50, 115, 220, 0.1);
}

.user-list {
  max-height: 500px;
  overflow-y: auto;
  margin-top: 12px;
}

.user-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  margin-bottom: 8px;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.user-card:hover {
  border-color: #3273dc;
  box-shadow: 0 2px 8px rgba(50, 115, 220, 0.15);
  transform: translateY(-1px);
}

.user-card.is-selected {
  background: #f0f7ff;
  border-color: #3273dc;
  border-width: 2px;
}

.user-info {
  flex: 1;
  min-width: 0;
}

.user-name {
  font-size: 0.95rem;
  font-weight: 600;
  color: #363636;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
}

.user-email {
  font-size: 0.85rem;
  color: #7a7a7a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-actions {
  display: flex;
  gap: 6px;
  margin-left: 12px;
}

/* Scrollbar personalizada */
.user-list::-webkit-scrollbar {
  width: 8px;
}

.user-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.user-list::-webkit-scrollbar-thumb {
  background: #b0b0b0;
  border-radius: 4px;
}

.user-list::-webkit-scrollbar-thumb:hover {
  background: #909090;
}

/* Responsive */
@media screen and (max-width: 1024px) {
  .modal-card {
    width: 95vw !important;
  }
  
  .columns {
    display: block !important;
  }
  
  .column {
    width: 100% !important;
  }
  
  .user-actions {
    flex-direction: column;
  }
}
</style>
